// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CountryContext from "../../country-config/context/CountryContext.bs.js";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as CrmControlledReleaseRepoManager from "../app/repo/CrmControlledReleaseRepoManager.bs.js";

function useBetaUserConfig(param) {
  var match = React.useState(function () {
        return {
                TAG: /* Loading */0,
                _0: undefined
              };
      });
  var updateBetaUserConfig = match[1];
  var RepoInstance = CrmControlledReleaseRepoManager.getRepo(undefined);
  var match$1 = CountryContext.useContext(undefined);
  var country = match$1.country;
  var $$fetch = function (param) {
    return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                  return Curry._1(RepoInstance.getAdminBetaAcessData, country);
                }), (function (data) {
                  return Curry._1(updateBetaUserConfig, (function (param) {
                                return {
                                        TAG: /* Live */1,
                                        _0: data
                                      };
                              }));
                }), (function (error) {
                  return Curry._1(updateBetaUserConfig, (function (param) {
                                return {
                                        TAG: /* Error */2,
                                        _0: error
                                      };
                              }));
                }));
  };
  React.useEffect((function () {
          $$fetch(undefined);
          
        }), []);
  return match[0];
}

export {
  useBetaUserConfig ,
  
}
/* react Not a pure module */
